import type { KiralamaDurumu } from '@emanetx/sdk';
import type { RozetTonu } from '@emanetx/ui';

export const DURUM_TONU: Record<KiralamaDurumu, RozetTonu> = {
  OLUSTURULDU: 'fume',
  ODEME_BEKLIYOR: 'turuncu',
  AKTIF: 'yesil',
  DOLAP_ACILDI: 'yesil',
  KULLANILIYOR: 'mavi',
  TESLIM_ALINIYOR: 'mavi',
  TAMAMLANDI: 'gri',
  IPTAL_EDILDI: 'gri',
  SURESI_GECTI: 'turuncu',
  SORUNLU: 'kirmizi',
};

export const DURUM_ETIKET: Record<KiralamaDurumu, string> = {
  OLUSTURULDU: 'Oluşturuldu',
  ODEME_BEKLIYOR: 'Ödeme Bekliyor',
  AKTIF: 'Aktif',
  DOLAP_ACILDI: 'Dolap Açıldı',
  KULLANILIYOR: 'Kullanılıyor',
  TESLIM_ALINIYOR: 'Teslim Alınıyor',
  TAMAMLANDI: 'Tamamlandı',
  IPTAL_EDILDI: 'İptal',
  SURESI_GECTI: 'Süresi Geçti',
  SORUNLU: 'Sorunlu',
};

/** "+90 532 *** ** 67" maskele (KVKK). */
export function telefonMaskele(telefon: string): string {
  // E.164 +905321234567
  const m = telefon.match(/^\+90(\d{3})\d{5}(\d{2})$/);
  if (!m) return telefon;
  return `+90 ${m[1]} *** ** ${m[2]}`;
}

/** "2s 37dk" gibi insancil sure formatlama. */
export function kalanSureyiBicimle(
  planlananBitis: string,
  bitis: string | null,
): {
  metin: string;
  asti: boolean;
} {
  if (bitis) return { metin: 'Tamamlandı', asti: false };
  const ms = new Date(planlananBitis).getTime() - Date.now();
  const asti = ms < 0;
  const mutlak = Math.abs(ms);
  const saat = Math.floor(mutlak / 3_600_000);
  const dakika = Math.floor((mutlak % 3_600_000) / 60_000);
  const metin = saat > 0 ? `${saat}s ${dakika}dk` : `${dakika}dk`;
  return { metin: asti ? `+${metin} aştı` : metin, asti };
}
